import { render, staticRenderFns } from "./AllTracksReleasesDialog.vue?vue&type=template&id=3c20bb92"
import script from "./AllTracksReleasesDialog.vue?vue&type=script&lang=js"
export * from "./AllTracksReleasesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports